import { render, staticRenderFns } from "./RoomsCard.vue?vue&type=template&id=0cbd00ce"
import script from "./RoomsCard.vue?vue&type=script&lang=js"
export * from "./RoomsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports